<template>
	<div @click.prevent="$emit('editNestedSelections')" @keyup.enter="$emit('editNestedSelections')" class="nested-options-section">
		<div v-for="(nestedOptionGroup, nestedOptionGroupTitle) in nestedSelections" :key="nestedOptionGroupTitle">
			{{ nestedOptionGroupTitle }}
			<div class="nested-options-selected">
				<div v-for="(selection, j) in nestedOptionGroup.selections" :key="j" class="option-text">
					&#9830; {{ selection.optionName }}
				</div>
			</div>
		</div>

		<button class="nested-edit-selections-footer" :aria-label="`Edit Options for ${parentLabel}`">
			<span class="nested-edit-selections-text">Edit Selections</span>
			<i class="fas fa-chevron-right edit-selections-chevron"></i>
		</button>
	</div>
</template>

<script>
export default {
	name: "NestedSelections",
	props: {
		nestedSelections: {
			type: Object,
			default: () => {},
		},
		parentLabel: {
			type: String,
			default: "Option",
		},
	},
};
</script>

<style lang="scss" scoped>
.nested-options-section {
	margin: 0 0 10px 5%;
	-webkit-transition: background-color 0.3s ease, transform 0.3s ease;
	transition: background-color 0.3s ease, transform 0.3s ease;
	font-weight: 500;
	padding: 11px;
	background-color: #eee;
	border-radius: 5px;
	box-shadow: 1px 1px 5px 0 rgba(171, 168, 168, 0.5);
	cursor: pointer;
	display: inline-block;
	width: 100%;
	max-width: 450px;
	&:hover,
	&:focus {
		transform: translate(0, -2px);
		.nested-edit-selections-text {
			text-decoration: underline;
		}
	}
}

.nested-options-selected {
	font-weight: 400;
	display: inline-block;
	margin-left: 5px;
	overflow: hidden;
	white-space: nowrap;
	width: 100%;
	text-overflow: ellipsis;
}

.option-text {
	display: inline-block;
	margin-left: 5px;
}

.nested-edit-selections-footer {
	border-top: 1px solid $gray_1;
	padding-top: 5px;
	display: flex;
	align-items: center;
}

.edit-selections-chevron {
	margin-left: 5px;
	font-size: 16px;
}
</style>
